<div class="payment-container">
  <label class="h4 font-weight-bold payment-heading">
    {{'PICK_A_PAYMENT_METHOD.PICK_A_PAYMENT_METHOD' | translate}}</label>
  <ul class="nav nav-tabs tabs-navigation" #masterNavigation>
    <li class="nav-item payment-nav-item" [class.active]="activeTab === 'instant_payment'">
      <a #payNowAnchor (click)="navigateToTab('instant_payment')">
        {{'PAYMENT.PAY_NOW' | translate}}
      </a>
    </li>
    <li class="nav-item payment-nav-item" [class.active]="activeTab === 'later_payment'">
      <a #payLaterAnchor (click)="navigateToTab('later_payment')">
        {{'PAYMENT.PAY_LATER.1' | translate}}
        {{this.globals.companyBillingOptions.invoicesDueDays}}
        {{'PAYMENT.PAY_LATER.2' | translate}}
      </a>
    </li>
    <div class="inn-moving-tab" #movingTab></div>
  </ul>
  <div class="tab-content">
    <div class="tab-pan active show" id="instantPayment" *ngIf="activeTab === 'instant_payment'">
      <app-payment-method-selector #instantPaymentMethodSelector
        (paymentMethodSelected)="paymentMethodSelected($event)"></app-payment-method-selector>
      <app-add-payment-method [hidden]="selectedSavedPaymentMethod != 'new_payment_method'"
                              (paymentMethodAdded)="savePaymentMethodIdAndPay($event)"
                              (loader)="changeLoaderState($event)"></app-add-payment-method>

      <div class="d-flex">
        <button mat-raised-button class="btn btn-fill btn-primary submit-payment-button"
                (click)="payByAutomaticInvoice()"
                id="submitButton"
                [disabled]="this.selectedSavedPaymentMethod == undefined"
                *ngIf="this.selectedSavedPaymentMethod !== 'bank_transfer'">
          <div class="hidden spinner"></div>
          <span class="button-text">{{'PAYMENT.PAY' | translate}} {{priceAmount}} €</span>
        </button>
        <div *ngIf="this.selectedSavedPaymentMethod === 'bank_transfer'" class="pay-now-container">
          <p>
            {{'PAYMENT.BANK_TRANSFER.WARNING' | translate}}
          </p>
          <button mat-raised-button class="btn btn-fill btn-primary submit-payment-button"
                  (click)="payByManualPayment()"
                  id="submitButton"
                  [disabled]="this.selectedSavedPaymentMethod == undefined">
            <div class="hidden spinner"></div>
            <span class="button-text">{{'PAYMENT.BANK_TRANSFER.SUBMIT' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="tab-pane active show" id="laterPayment" *ngIf="activeTab === 'later_payment'">
      <div class="time-select-container align-items-center justify-content-center">
        <div class="btn-group btn-group-toggle time-select-btn-group" data-toggle="buttons">
          <label class="btn btn-secondary" [class.active]="laterPaymentActiveOption == 'download'" (click)="setLaterPaymentActiveOption('download')">
            <input type="radio" name="options" autocomplete="off"
                   checked> {{'PAYMENT.DOWNLOAD_INVOICE.TITLE' | translate}}
          </label>
          <label class="btn btn-secondary" [class.active]="laterPaymentActiveOption == 'sepa'" (click)="setLaterPaymentActiveOption('sepa')">
            <input type="radio" name="options" autocomplete="off"> {{'PAYMENT.SEPA_DIRECT_DEBIT.TITLE' | translate}}
          </label>
        </div>
      </div>
      <div class="later-payment-container" [hidden]="laterPaymentActiveOption != 'download'">
        <p>
          {{'PAYMENT.DOWNLOAD_INVOICE.BODY_1' | translate}}
          {{this.globals.companyBillingOptions.invoicesDueDays}}
          {{'PAYMENT.DOWNLOAD_INVOICE.BODY_2' | translate}}
        </p>
        <ul>
          <li>
            <b>{{'PAYMENT.DOWNLOAD_INVOICE.BANK_TRANSFER.TITLE' | translate}}</b>
            {{'PAYMENT.DOWNLOAD_INVOICE.BANK_TRANSFER.BODY.1' | translate}}
            <i>{{'PAYMENT.DOWNLOAD_INVOICE.BANK_TRANSFER.BODY.2' | translate}}</i>
          </li>
          <li>
            <b>{{'PAYMENT.DOWNLOAD_INVOICE.CARD_SEPA.TITLE' | translate}}</b>
            {{'PAYMENT.DOWNLOAD_INVOICE.CARD_SEPA.BODY.1' | translate}}
            <i>{{'PAYMENT.DOWNLOAD_INVOICE.CARD_SEPA.BODY.2' | translate}}</i>
            {{'PAYMENT.DOWNLOAD_INVOICE.CARD_SEPA.BODY.3' | translate}}
          </li>
        </ul>
        <div class="d-flex justify-content-center">
          <button id="payBillLaterButton" mat-raised-button class="btn btn-fill btn-primary submit-payment-button"
                  (click)="payByLaterStripeBill()">
            <div class="spinner hidden"></div>
            <span class="button-text">{{'PAYMENT.DOWNLOAD_INVOICE.SUBMIT' | translate}}</span>
          </button>
        </div>
      </div>
      <div class="automatic-payment-container" [hidden]="laterPaymentActiveOption != 'sepa'">
        <p>
          {{'PAYMENT.SEPA_DIRECT_DEBIT.BODY.1' | translate}}
          {{this.priceAmount}}
          {{'PAYMENT.SEPA_DIRECT_DEBIT.BODY.2' | translate}}
          {{this.scheduledPaymentDate}}
          {{'PAYMENT.SEPA_DIRECT_DEBIT.BODY.3' | translate}}
        </p>
        <div class="payment-method-selector-container">
          <app-payment-method-selector
            #laterPaymentMethodSelector
            [methodsAllowed]="['sepa_debit']"
            (paymentMethodSelected)="paymentMethodSelected($event)"></app-payment-method-selector>
          <app-add-payment-method [hidden]="selectedSavedPaymentMethod != 'new_payment_method'"
                                  (paymentMethodAdded)="savePaymentMethodIdAndDirectDebit($event)"
                                  (loader)="changeLoaderState($event)"
                                  [singleType]="true"
                                  [typeAllowed]="'type_iban_element'"></app-add-payment-method>
        </div>
        <div class="d-flex justify-content-center">
          <button mat-raised-button class="btn btn-fill btn-primary submit-payment-button"
                  (click)="payBySepaDirectDebit()" id="paySepaDirectDebitButton">
            <div class="hidden spinner"></div>
            <span class="button-text">{{'PAYMENT.SEPA_DIRECT_DEBIT.SUBMIT' | translate}} {{this.priceAmount}} €</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
